module.exports = __webpack_public_path__ + "static/media/ta-rpo-02.edb17963.png";